module.exports = __webpack_public_path__ + "static/img/zhongguoyidong-caise@2x.8fcefe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partners/zhongguoyidong-caise@2x.png
// module id = +zkf
// module chunks = 1